import { useContext, useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router";
import { Box } from "@mui/material";
import authorityUserType from "../../assets/data/TkAuthorityProperty";
import { GlobalContext } from "../../context/globalContext";
import { BusinessContext } from "../../context/businessContext";
import TkStepper from "../../components/atoms/TkStepper";
import TkFakeTable from "../../components/molecules/TkFakeTable";
import TkBackButton from "../../components/molecules/TkBackButton";
import TkMessageDialog from "../../components/molecules/TkMessageDialog";
import { API_RET005_BuildReqParams } from "../../utils/buildRequestParams";
import { httpAPI_RET005 } from "./api/request.formdata";
import { IAPI_RET005_Request } from "../../type/apiType";
import { fakeTableList, schema, steps } from "./parts";
import _ from "lodash";

/**
 * SCRR411124 退職手当金受領者の変更手続き（振込先金融機関の登録）
 * 退職手当金受領者を変更する際の変更後の受領者の振込先金融機関を登録する。
 * @return SCRR411124
 */
const SCRR411124 = () => {
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const { state, setState } = useContext(GlobalContext);
  const { state: businessState, setState: setBusinessState } =
    useContext(BusinessContext);
  const isKiko =
    state.authInfo?.userType === authorityUserType.userTypeNumber.KIKO;
  const context = businessState.job_41;
  const [stateTableList, setStateTableList] = useState<any>([]);
  const [bankInfo, setBankInfo] = useState<any>({});

  const stateFakeTableList = useRef(_.cloneDeep(fakeTableList));

  useEffect(() => {
    // 持回情報を初期表示する
    let resArr = stateFakeTableList.current;

    for (let i in context) {
      let targetObj = resArr.find((item) => item.keyword === i);

      if (i === "depositType") continue;

      if (targetObj && context[i as keyof typeof context]) {
        targetObj.text = context[i as keyof typeof context];
        targetObj.setDefaultValue = context[i as keyof typeof context];
      }
    }

    // 退職者名
    let retireeName = resArr.find((item) => item.keyword === "retireeName")!;
    retireeName.showLine = isKiko;
    retireeName.contractorNumber = context?.retirementStaffName;

    // 振込先金融機関
    let bankInfo = {
      bankCode: context?.bankCd,
      bankNameKatakana: context?.bankName,
      branchCode: context?.branchCd,
      branchNameKatakana: context?.branchName,
    };
    if (Object.values(bankInfo).every((i) => i)) {
      resArr.find((item) => item.keyword === "bankSelect")!.setDefaultValue =
        bankInfo;
      setBankInfo(bankInfo);
    }

    setStateTableList([...resArr]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    let resArr = stateFakeTableList.current;
    let bankSelection = resArr.find((item) => item.keyword === "bankSelect")!;

    bankSelection.onSuccessfulWithBank = (value: any) => {
      resArr.find((item) => item.keyword === "bankCd")!.text = value.bankCode;
      resArr.find((item) => item.keyword === "bankName")!.text =
        value.bankNameKatakana;
      resArr.find((item) => item.keyword === "branchCd")!.text =
        value.branchCode;
      resArr.find((item) => item.keyword === "branchName")!.text =
        value.branchNameKatakana;

      setBankInfo(value);
    };

    setStateTableList([...resArr]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state]);

  const makeHttpObj = (obj: any): IAPI_RET005_Request => {
    const reqObj: IAPI_RET005_Request = {
      ...context,
      fileList: context?.fileList ?? [],
      ...obj,
      tempSaveStep: 6,
      businessType: businessState.common?.businessType,
      contractorNo: isKiko
        ? businessState.common?.contractorNo
        : state.authInfo?.contractorNo,
      screenId: "SCRR411124",
    };
    return API_RET005_BuildReqParams(reqObj);
  };

  const handleSubmit = async (data: any, index: any) => {
    const dataObj = {
      bankCd: bankInfo.bankCode,
      bankName: bankInfo.bankNameKatakana,
      branchCd: bankInfo.branchCode,
      branchName: bankInfo.branchNameKatakana,
      depositType: data.depositType,
      accountNo: data.accountNo,
      accountNameKana: data.accountNameKana,
    };

    switch (index) {
      case 0: // 一時保存
        // 退職手当金請求更新API実行
        try {
          const res = await httpAPI_RET005({
            ...makeHttpObj(dataObj),
          });

          if (res.resultCd === "I0000") {
            setState({
              ...state,
              errorMsgId: "",
            });
            setBusinessState({
              ...businessState,
              job_41: {
                ...context,
                ...dataObj,
                applyId: res.applyId,
                tempSaveStep: 6,
              },
            });

            setOpen(true);
          } else {
            setState({
              ...state,
              errorMsgId: res.resultCd,
            });
          }
        } catch (error) {
          navigate("/error");
        }
        break;

      case 1: // 次へ
        setBusinessState({
          ...businessState,
          job_41: {
            ...context,
            ...dataObj,
          },
        });

        navigate("/SCRR411125");
        break;
    }
  };

  return (
    <Box data-testid="SCRR411124test">
      <TkStepper
        steps={steps}
        activeStep={5}
        savaStep={context?.tempSaveStep}
      />

      <TkFakeTable
        list={stateTableList}
        ruleSchema={schema}
        submitButtonGroup={[
          { submitButtonText: "一時保存" },
          { submitButtonText: "次へ" },
        ]}
        buttonGroup={<TkBackButton />}
        onCheckAndSubmit={(e, index) => handleSubmit(e, index)}
      />
      <TkMessageDialog
        open={open}
        onOky={() => setOpen(false)}
        title="一時保存完了"
        contextText="　一時保存が完了しました。"
        okText="はい"
        cancelText=""
      />
    </Box>
  );
};

export default SCRR411124;
